<template>
  <div class="list-group list-group-flush list-group-sm">
    <template v-for="(item, key) in items">
      <GuTooltip v-if="item.total" :key="key">
        <template #trigger>
          <a
            :href="item.url"
            :class="['list-group-item list-group-item-action d-flex gap-2 align-items-center border-0', reversed && 'flex-row-reverse']"
            :aria-label="buildAriaLabel(item)"
          >
            <span class="badge" :style="`--gu-badge-empty-size: 1rem; background-color: ${item.color};`" />
            <span v-if="showLabel" class="pe-4 me-auto">{{ item.label }}</span>
            <span v-if="showCount" class="badge text-bg-light rounded-pill">{{ item.total.toLocaleString() }}</span>
          </a>
        </template>
        <ChartLegendTooltip :values="item.values" />
      </GuTooltip>
    </template>
  </div>
</template>

<script setup>
import { computed, toRefs } from 'vue'
import { GuTooltip } from '@shared/gu-components/tooltip'
import ChartLegendTooltip from '@projects/components/ChartLegendTooltip.vue'

const props = defineProps({
  items: {
    type: Array,
    default: () => ([]),
  },
  showLabel: {
    type: Boolean,
    default: true,
  },
  showCount: {
    type: Boolean,
    default: false,
  },
  ariaLabel: {
    type: String,
    default: '',
  },
})

const { items, showLabel, showCount, ariaLabel } = toRefs(props)

const reversed = computed(() => !showLabel.value && showCount.value)

function buildAriaLabel (item) {
  return `${item.value} ${item.label} ${ariaLabel.value} applications`
}
</script>
